import { render, staticRenderFns } from "./AssignedJob.vue?vue&type=template&id=ecb32b8c&scoped=true"
import script from "./AssignedJob.vue?vue&type=script&lang=js"
export * from "./AssignedJob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb32b8c",
  null
  
)

export default component.exports